import { RootState } from 'configs/redux';

export const registrationSelector = (state: RootState) => state.registration;
